import React from 'react';
import { Modal, Typography, List, Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import './ResellerDashboard.scss';

const { Title, Text } = Typography;

interface TutorialsModalProps {
	isOpen: boolean;
	onClose: () => void;
	tutorialItems: {
		icon: React.ReactNode;
		title: string;
		description: string;
		url: string;
	}[];
	children?: React.ReactNode;
}

const TutorialsModal: React.FC<TutorialsModalProps> = ({
	isOpen,
	onClose,
	tutorialItems,
	children = null,
}) => {
	const handleTutorialClick = (url: string) => {
		window.open(url, '_blank');
	};

	return (
		<Modal
			title={
				<div className="mb-4">
					<Title level={4}>Tutorials & Resources</Title>
					<Text type="secondary" className="font-normal">
						Learn how to effectively manage your account and configure your AI Frontdesk.
					</Text>
				</div>
			}
			open={isOpen}
			onCancel={onClose}
			footer={null}
			width={600}
		>
			<List
				itemLayout="horizontal"
				dataSource={tutorialItems}
				split={false}
				renderItem={(item) => (
					<List.Item
						className="cursor-pointer hover:bg-gray-100 rounded-lg transition-colors"
						onClick={() => handleTutorialClick(item.url)}
					>
						<div className="flex items-center w-full px-3">
							<div className="flex-shrink-0 mr-4">{item.icon}</div>
							<div className="flex-grow">
								<Text strong className="block text-lg">
									{item.title}
								</Text>
								<Text type="secondary">{item.description}</Text>
							</div>
						</div>
					</List.Item>
				)}
			/>

			<div className="flex justify-end mt-6 pt-4 border-t border-gray-100">
				<div className="flex gap-2 items-center">
					{children}
					<Button
						type="primary"
						size="large"
						className="flex items-center"
						onClick={() =>
							window.open('https://www.myaifrontdesk.com/reseller-tutorials', '_blank')
						}
					>
						<span>View All Tutorials</span>
						<ArrowRightOutlined className="ml-2" />
					</Button>
				</div>
			</div>
		</Modal>
	);
};

export default TutorialsModal;
